/** Authored radio callouts for the high-signal upgrade moments. */

export const TOP_TIER_CALLOUTS: Record<string, string> = {
  ballistic: 'Deadeye Overwatch',
  thermal: 'Solar Pyre',
  artillery: 'Siegefall',
  energy: 'Singularity Lance',
  vulcan: 'Stormfeed',
  sabre: 'Theatre Strike',
  tesla: 'Storm Lattice',
  cryo: 'Whiteout Crown',
  dronehive: 'Apogee Swarm',
};

export const SYMBIOSIS_COMBO_NAMES: Record<string, string> = {
  'ballistic:pod_missile': 'Skyfall Talon',
  'ballistic:pod_autocannon': 'Twin Talon',
  'ballistic:pod_laser': 'Redline Lance',
  'ballistic:pod_cluster': 'Shrapnel Rain',
  'ballistic:pod_uplink': 'Hawk-Eye Lock',

  'thermal:pod_cryo': 'Burning Ice',
  'thermal:pod_frost': 'Cinderfrost',
  'thermal:pod_plasma': 'Sunfire Spear',
  'thermal:pod_missile': 'Emberfall Salvo',
  'thermal:pod_shield': 'Furnace Aegis',

  'artillery:pod_missile': 'Thunder Payload',
  'artillery:pod_autocannon': 'Close Quarters Siege',
  'artillery:pod_cluster': 'Iron Rain',
  'artillery:pod_frost': 'Winter Barrage',
  'artillery:pod_uplink': 'Longshot Doctrine',

  'energy:pod_arc': 'Arc Communion',
  'energy:pod_laser': 'Prism Lance',
  'energy:pod_plasma': 'Starfire',
  'energy:pod_uplink': 'Lattice Sight',
  'energy:pod_shield': 'Aegis Circuit',

  'vulcan:pod_missile': 'Tornado Salvo',
  'vulcan:pod_salvo': 'Cyclone Storm',
  'vulcan:pod_autocannon': 'Twin Tempest',
  'vulcan:pod_laser': 'Red Cyclone',
  'vulcan:pod_cluster': 'Shredder Rain',
  'vulcan:pod_uplink': 'Gyro Lock',

  'sabre:pod_autocannon': 'Gunmetal Wing',
  'sabre:pod_missile': 'Sabrefall',
  'sabre:pod_cluster': 'Shard Salvo',
  'sabre:pod_plasma': 'Comet Burn',
  'sabre:pod_uplink': 'Hunter Vector',

  'tesla:pod_arc': 'Tempest Chain',
  'tesla:pod_laser': 'Lattice Beam',
  'tesla:pod_cryo': 'Frozen Circuit',
  'tesla:pod_uplink': 'Arc Sight',

  'cryo:pod_cryo': 'Whiteout Core',
  'cryo:pod_frost': 'Absolute Zero',
  'cryo:pod_plasma': 'Thermal Shock',
  'cryo:pod_missile': 'Frostfall Salvo',
  'cryo:pod_shield': 'Glacial Aegis',

  'dronehive:pod_autocannon': 'Waspstorm',
  'dronehive:pod_missile': 'Hivefire',
  'dronehive:pod_cluster': 'Bomblet Swarm',
  'dronehive:pod_uplink': 'Shared Eyes',
};

export const comboKey = (towerId: string, moduleId: string): string => `${towerId}:${moduleId}`;

export const comboVoiceId = (towerId: string, moduleId: string): string => `combo_${towerId}_${moduleId}`;

export const topTierVoiceId = (towerId: string): string => `top_tier_${towerId}`;

export const researchVoiceId = (researchId: string): string => `research_${researchId}`;
